

import { Typography, Button, Box } from "@mui/material";
// import { Cancel } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// const FailureData = {
//   error: {
//     code: "card_declined",
//     doc_url: "https://stripe.com/docs/error-codes/card-declined",
//     message: "Your card was declined.",
//     param: "payment_method",
//     payment_intent: {
//       id: "pi_3XYZ123",
//       object: "payment_intent",
//       amount: 5000,
//       currency: "usd",
//       status: "requires_payment_method",
//       last_payment_error: {
//         code: "card_declined",
//         message: "Your card was declined.",
//         type: "card_error",
//       },
//     },
//     type: "card_error",
//   },
// };

type sessionData = {
  status: string;
  name: string;
  email: string;
  mode: string;
  sessionId: string;
  url: string;
};

const Failure = () => {
  const [isFailureData, setFailureData] = useState<sessionData>();
  const [searchParams] = useSearchParams();
  const session_id = searchParams.get("session_id")
  // const [sessionDetails, setSessionDetails] = useState<sessionData | null>(
  //   null
  // );

  const calledRef = useRef(false); // useRef to persist value

  useEffect(() => {
    const getUserDetail = async () => {
      if (calledRef.current) return; // Prevent duplicate call
      calledRef.current = true;

      try {
        const response = await axios.get(
          `${API_BASE_URL}payment/payment-status/${session_id}`
        );
        if (response.status >= 200 && response.status <= 300) {
          setFailureData(response.data.data);
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname
          );
        }
      } catch (err) {
        console.log(err);
      }
    };

    if (session_id) {
      getUserDetail();
    }
  }, [session_id]);


  return (
    <Box
      sx={{
        backgroundColor: "#fff8f8",
        width: "100vw",
        height: "100vh",
        display: "inline-block",
        alignContent: "center",
      }}
    >
      {/* <Box
        textAlign="center"
        mt={0}
        sx={{
          backgroundColor: "#fff",
          width: "fit-content",
          margin: "0 auto",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0px 2px 8px #adadad",
          maxWidth: "400px",
        }}
      >
        <>
          <Cancel sx={{ fontSize: 60, color: "red" }} />
          <Typography
            variant="h5"
            sx={{ color: "red", fontWeight: "bold", mt: 1 }}
          >
            Payment Failed ❌
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            Oops! <b>{isFailureData.error.message}</b>
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
            Please check your payment details or try a different payment method.
            If the issue persists, contact support.
          </Typography>
          <Box mt={2}>
            <Button variant="contained" color="error" sx={{ width: "auto" }}>
              Try Again
            </Button>
          </Box>
        </>
      </Box> */}
      {isFailureData?.status === "unpaid" ? 
      <>
        <Box
          sx={{
            backgroundColor: "#c7ffdb",
            width: "100vw",
            height: "100vh",
            display: "inline-block",
            alignContent: "center",
          }}
        >
          <Box
            textAlign="center"
            mt={0}
            sx={{
              backgroundColor: "#fff",
              width: "fit-content",
              margin: "0 auto",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0px 2px 8px #adadad",
            }}
          >
            <>
              <Box sx={{ fontSize: "50px" }}>⏳</Box>

              <Box
                sx={{
                  color: "orange",
                  fontWeight: "bold",
                  fontSize: "24px",
                  padding: "10px 0",
                }}
              >
                Payment Pending
              </Box>
              <Box sx={{ padding: "10px 0" }}>
                <Typography variant="body1">
                  Your subscription process is in progress. We are awaiting
                  confirmation of your payment.
                </Typography>
              </Box>

              <Box mt={2}>
                <Button
                  variant="contained"
                  color="success"
                  //   onClick={onClose}
                  sx={{ width: "fit-content" }}
                  onClick={() => (window.location.href = isFailureData?.url)} // Redirect to external domain
                >
                  Go to Checkout
                </Button>
              </Box>
            </>
          </Box>
        </Box>
      </> : "" }
      
    </Box>
  );
};

export default Failure;
